<template lang="">
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Nhóm khoản lương"
            :link="[
              { text: 'Nâng cao', href: '/salary-collection', disabled: false },
              { text: 'Nhóm khoản lương', href: '/salary-collection', disabled: false }
            ]"
          />
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-end">
          <v-btn class="ml-6" depressed color="primary" @click="() => $refs.createCollectionDialog.openDialog()">
            <v-icon left>add</v-icon>
            Thêm nhóm
          </v-btn>
        </div>
      </div>
      <v-card outlined class="mx-4 elevation-0" md>
        <CollectionTable />
      </v-card>

      <CreateCollectionDialog style="margin: 0 20px" ref="createCollectionDialog" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import CollectionTable from './collection-list/CollectionTable.vue'
import CreateCollectionDialog from './collection-list/CreateCollectionDialog.vue'

export default {
  components: {
    Breadcrumbs,
    CollectionTable,
    CreateCollectionDialog
  }
}
</script>
